import React from 'react';

import usePriceLabel from '@travel/traveler-core/hooks/usePriceLabel';
import { cx } from '@travel/utils';

import Money from 'components/Money';
import PriceLabel from 'components/PriceLabel';

import { PROVIDER_CONTRACT_TYPES } from 'constants/provider';
import { Translate } from 'core/translate';
import type { ProviderItem, SearchFormQuery } from 'ProviderList-Types';

import styles from './providerBox.module.scss';

type Props = {
  className?: string;
  /** Object of provider data */
  item: ProviderItem;
  /** object of current pge query */
  query?: SearchFormQuery;
  /** Flag to define whether the component will be an expanded style or not */
  isExpandedMapStyle?: boolean;
};

function ProviderPriceBox(props: Props) {
  const { item, query } = props;
  const { guestCount, nightLabel, roomsLabelText } = usePriceLabel(query);
  const isDirectContract = item.contractType === PROVIDER_CONTRACT_TYPES.DIRECT;

  if (!item.price) {
    return null;
  }

  return (
    <PriceLabel
      className={cx(props.className, styles.priceBox)}
      price={item.price}
      planPaymentRestrictionFeature={item?.paymentRestrictionFeature}
      hasTotalPriceSuffix={true}
      PriceComponent={props => <Money {...props} roundPosition={isDirectContract ? null : -1} />}
      isShowPlanPaymentRestriction={true}
      nightsLabel={nightLabel}
      guestsLabel={
        <Translate
          id="Provider_List.Search.Guests"
          count={guestCount}
          data={{ number_of_guests: guestCount }}
        />
      }
      roomsLabel={isDirectContract ? <></> : roomsLabelText}
      chargeUnit={
        isDirectContract ? (
          <Translate id="Provider_List.Search_Results.Per_Room" />
        ) : (
          <Translate id="Provider_List.Out_To_Out.Search_Results.Per_Room_Per_Night" />
        )
      }
      isRowDiscountRateTag
      taxesLabel={isDirectContract ? <></> : <Translate id="Provider_List.Search_Results.Taxes" />}
      isDirectContract={isDirectContract}
    />
  );
}

export default ProviderPriceBox;
